module.exports = __webpack_public_path__ + "static/media/logo-rotten-tomatoes.40053bdf.svg";